import React from 'react';
import { Helmet } from "react-helmet";
import { useLocation, useRoutes } from "react-router-dom";
import PublicLayout from '../layouts/PublicLayout';
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import PrivateLayout from '../layouts/PrivateLayout';
import Home from '../pages/home/home';
import EditProfile from '../pages/editProfile/editProfile';
import Signup from '../pages/signup/signup';
import Login from "../pages/signin/signin"
import { CompleteProfile } from '../pages/completeProfile/completeProfile';
import Profile from '../pages/profile/profile';
import ForgetPassword from '../pages/forgetPassword/forgetPassword';
import { OtpVerification } from '../pages/otpVerification/otpVerification';
import Course from '../pages/course/course';
import StartCourse from '../pages/startCourse/startCourse';
import RatingReview from '../pages/ratingAndReview/ratingReview';
import VideoPlayer from '../pages/videoPlayer/videoPlayer';
import Blog from '../pages/blog/blog';
import BlogDetails from '../pages/blogDetails/blogDetails';
import SetupNewPassword from '../pages/setupNewPassword/setupNewPassword';
import { Test } from '../pages/test/test';
import ContactUs from '../pages/contactUs/contactUs';
import AboutUs from '../pages/aboutUs/aboutUs';
import Faq from '../pages/faq/faq';
import TnC from '../pages/TnC/TnC';
import PrivacyPolicy from '../pages/privacyPolicy/privacyPolicy';
import { CommunityForum } from '../pages/communityForum/communityForum';
import { CourseDetails } from '../pages/courseDetails/courseDetails';
import StartTest from '../pages/startTest/startTest';
import { Cart } from '../pages/cart/cart';
import ComplaintFeedbackForm from '../pages/complaintFeedbackForm/complaintFeedbackForm';
import AnimationVideos from '../pages/animationVideos/animationVideos';
import FavouriteCourses from '../pages/favouriteCourses/favouriteCourses';
import ErrorPage from '../pages/errorPage/errorPage';
import TrainerRatingReview from '../pages/trainerRatingReview/trainerRatingReview';
import Chat from '../pages/chat/chat';
import ScrollToTop from '../components/scrollToTop/scrollToTop';
import Notification from '../pages/notification/notification';
import VerifyCertificate from '../pages/verifyCertificate/verifyCertificate';
import BlankLayout from '../layouts/BlankLayout';
import AccountDeletion from '../pages/accountDeletion/accountDeletion';
import BuyCourse from '../pages/buyCourse/buyCourse';

const blankLayoutPaths = [
    '/app-privacy-policy',
    '/app-tandc',
    '/app-about-us',
    '/app-faq',
    '/account-deletion'
];

const RouterContainer = () => {

    const location = useLocation();

    const isBlankLayout = blankLayoutPaths.some(path =>
        location.pathname.startsWith(path)
    );

    const routes = [
        {
            path: "/",
            element: <PublicLayout />,
            children: [
                {
                    path: "/",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech </title>
                            </Helmet>
                            <Home />
                        </>
                    )
                },
                {
                    path: "/sign-in",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Sign-in </title>
                            </Helmet>
                            <Login />
                        </>
                    ),
                },
                {
                    path: "/sign-up",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Sign-up </title>
                            </Helmet>
                            <Signup />
                        </>
                    )
                },
                {
                    path: "/forgot-password/:type",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Forget password </title>
                            </Helmet>
                            <ForgetPassword />
                        </>
                    )
                },
                {
                    path: "/otp-verification",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Verify OTP </title>
                            </Helmet>
                            <OtpVerification />
                        </>
                    )
                },
                {
                    path: "/setup-new-password",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Set new password </title>
                            </Helmet>
                            <SetupNewPassword />
                        </>
                    )
                },
                {
                    path: "/buy-course",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Buy Course </title>
                            </Helmet>
                            <BuyCourse/>
                        </>
                    )
                },
            ]
        },
        {
            path: "/",
            element: <PrivateLayout />,
            children: [
                {
                    path: "/complete-profile",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Complete Profile </title>
                            </Helmet>
                            <CompleteProfile />
                        </>
                    )
                },
                {
                    path: "/home",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Home </title>
                            </Helmet>
                            <Home />
                        </>
                    )
                },
                {
                    path: "/edit-profile",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Edit Profile </title>
                            </Helmet>
                            <EditProfile />
                        </>
                    )
                },
                {
                    path: "/profile",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | My Profile </title>
                            </Helmet>
                            <Profile />
                        </>
                    )
                },
                {
                    path: "/course",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | My Course </title>
                            </Helmet>
                            <Course />
                        </>
                    )
                },
                {
                    path: "/start-course/:data",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Start Course </title>
                            </Helmet>
                            <StartCourse />
                        </>
                    )
                },
                {
                    path: "/rating-and-review/:id",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Course rating-review </title>
                            </Helmet>
                            <RatingReview />
                        </>
                    )
                },
                {
                    path: "/lesson/:data",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Course Video </title>
                            </Helmet>
                            <VideoPlayer />
                        </>
                    )
                },
                {
                    path: "/test",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Test </title>
                            </Helmet>
                            <Test />
                        </>
                    )
                },
                {
                    path: "/blog",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Blogs </title>
                            </Helmet>
                            <Blog />
                        </>
                    )
                },
                {
                    path: "/contact-us",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Contact us </title>
                            </Helmet>
                            <ContactUs />
                        </>
                    )
                },
                {
                    path: "/community-forum",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Community Forum </title>
                            </Helmet>
                            <CommunityForum />
                        </>
                    )
                },
                {
                    path: "/course-details/:data",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Course Details </title>
                            </Helmet>
                            <CourseDetails />
                        </>
                    )
                },
                {
                    path: "/start-test/:id",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Start Test </title>
                            </Helmet>
                            <StartTest />
                        </>
                    )
                },
                {
                    path: "/cart",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Cart </title>
                            </Helmet>
                            <Cart />
                        </>
                    )
                },
                {
                    path: "/complaint-feedback",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Complaint Feedback </title>
                            </Helmet>
                            <ComplaintFeedbackForm />
                        </>
                    )
                },
                {
                    path: "/animation-videos",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Animation Videos </title>
                            </Helmet>
                            <AnimationVideos />
                        </>
                    )
                },
                {
                    path: "/favourite-course",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Favourite Courses </title>
                            </Helmet>
                            <FavouriteCourses />
                        </>
                    )
                },
                {
                    path: "/trainer-rating-and-review/:id",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Trainer rating-review </title>
                            </Helmet>
                            <TrainerRatingReview />
                        </>
                    )
                },
                {
                    path: "/chat",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Chat </title>
                            </Helmet>
                            <Chat />
                        </>
                    )
                },
                {
                    path: "/notification",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Notification </title>
                            </Helmet>
                            <Notification />
                        </>
                    )
                }
            ]
        },
        {
            path: "/privacy-policy",
            element: (
                <>
                    <Helmet>
                        <title>Guarding.Tech | Privacy Policy </title>
                    </Helmet>
                    <PrivacyPolicy />
                </>
            )
        },
        {
            path: "/tandc",
            element: (
                <>
                    <Helmet>
                        <title>Guarding.Tech | Terms and Conditions </title>
                    </Helmet>
                    <TnC />
                </>
            )
        },
        {
            path: "/blog-details/:id",
            element: (
                <>
                    <Helmet>
                        <title>Guarding.Tech | Blog Details </title>
                    </Helmet>
                    <BlogDetails />
                </>
            )
        },
        {
            path: "/about-us",
            element: (
                <>
                    <Helmet>
                        <title>Guarding.Tech | About us </title>
                    </Helmet>
                    <AboutUs />
                </>
            )
        },
        {
            path: "/faq",
            element: (
                <>
                    <Helmet>
                        <title>Guarding.Tech | FAQ </title>
                    </Helmet>
                    <Faq />
                </>
            )
        },
        {
            path: "/verify",
            element: (
                <>
                    <Helmet>
                        <title>Guarding.Tech | Certificate</title>
                    </Helmet>
                    <VerifyCertificate />
                </>
            )
        },
        {
            path: "*",
            element: (
                <>
                    <Helmet>
                        <title>Guarding.Tech | Page not found </title>
                    </Helmet>
                    <ErrorPage />
                </>
            )
        },
        {
            path: '/',
            element: <BlankLayout />,
            children: [
                {
                    path: "/app-tandc",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Terms and Conditions </title>
                            </Helmet>
                            <TnC />
                        </>
                    )
                },
                {
                    path: "/app-privacy-policy",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Privacy Policy </title>
                            </Helmet>
                            <PrivacyPolicy />
                        </>
                    )
                },
                {
                    path: "/app-faq",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | FAQ </title>
                            </Helmet>
                            <Faq />
                        </>
                    )
                },
                {
                    path: "/app-about-us",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | About us </title>
                            </Helmet>
                            <AboutUs />
                        </>
                    )
                },
                {
                    path: "/account-deletion",
                    element: (
                        <>
                            <Helmet>
                                <title>Guarding.Tech | Account Deletion </title>
                            </Helmet>
                            <AccountDeletion />
                        </>
                    )
                },
            ]

        }
    ]

    const routing = useRoutes(routes);

    return (
        <>
            {isBlankLayout ? (
                <>
                    <main className="bg-white min-vh-100">
                        {routing}
                    </main>
                    <ScrollToTop />
                </>
            ) : (
                <div className="app-container">
                    <Header />
                    <main className="main-content bgBrown">
                        {routing}
                    </main>
                    <Footer />
                    <ScrollToTop />
                </div>
            )}
        </>
    )
}

export default RouterContainer;
